export default __webpack_public_path__ + "static/multiple-pipelines-switching-pipelines-opportunity-d17f5264c78b94389bde11b7dc1a5a4d.mp4";